module.exports = __webpack_public_path__ + "img/inco2Ac.f91eb21f.png";